import { TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV, BASE_PATH_API, BASE_PATH_PORTAL } from 'constants/general';
import axios from 'axios';
import { decodeStorage } from 'functions/storageBase64';

export async function postLoginTelmex(data) {

    const access_token = decodeStorage('access_token')
    
    console.log("data-telmex-login:",data);

    let apiURL;
    
    if(STAGE_DIRNAME === "dev"){
        //BASE_PATH_PORTAL
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/telmex/login-onboard`
    }else{
        apiURL = `${BASE_PATH_API}/telmex/login-onboard`
    }

    const raw = data;

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        },
        data: raw
    };

    return await axios(config)
        .then(res => {
            const {
                headers,
                status,
                data
            } = res
            console.log("postNip:",data);
            return {
                'headers': headers,
                'statusCode': status,
                'data': data,
                'error': ''
            }
        })
        .catch(error => {
            return {
                'headers': '',
                'statusCode': error?.request?.status,
                'data': error?.response?.data,
                'error': error?.response?.data?.codMen
            }
        })
}
